import qs from 'query-string'
import type { IDashboardFilter, IModelFieldSuggestions, IRequestModelFieldnameSuggestions } from '@looker/sdk'

import { api } from '@/api'
import { session } from '@/composables/useSession'

import type { InitialAssignmentFilter, LookerDashboard } from '../looker/types'

export const getLookerDashboards = () =>
  api
    .get('looker/dashboards', { headers: { 'X-Klaus-Workspace': session.workspace.id.toString() } })
    .json<{ dashboards: LookerDashboard[]; lookerRegionalInstance?: string }>()

export const getInitialAssignmentFilterData = async () => {
  return await api
    .get('assignments/v2/looker/filter', { headers: { 'X-Klaus-Workspace': session.workspace.id.toString() } })
    .json<InitialAssignmentFilter>()
}

export const getLookerDashboardFilters = (id: string) =>
  api.get(`looker/dashboards/${id}/filters`).json<{ dashboard_filters: IDashboardFilter[] }>()

export const getLookerFilterFieldSuggestions = ({
  model_name,
  view_name,
  field_name,
  term,
  filters,
}: IRequestModelFieldnameSuggestions) =>
  api
    .get(`looker/models/${model_name}/views/${view_name}/fields/${field_name}/suggestions`, {
      searchParams: qs.stringify({ term, filters }),
    })
    .json<IModelFieldSuggestions>()
